import React, { useState } from 'react'
import Body from './typography/Body'
export default function QuizCardIconHover({ title, content, ...props }) {
  const [hover, setHover] = useState(false)
  const handleHover = () => {
    setHover(!hover)
  }

  return (
    <div
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
      className="z-10 cursor-pointer"
    >
      {props.children}
      <div
        className={` absolute top-0 overflow-hidden left-0 z-0  h-[130px] flex items-center animate-fade rounded-md transition-all text-black w-full p-10 bg-opacity-100 ${
          hover ? 'visible' : 'hidden'
        }`}
      >
        <div className="bg-white w-full h-full p-10 rounded-md opacity-90">
          <Body className="font-bold">{title}</Body>
          <Body>{content}</Body>
        </div>
      </div>
    </div>
  )
}
